import { useCallback } from 'react';
import styled from 'styled-components';
import UIButton from 'UIComponents/button/UIButton';
import { useTableDispatch, useTableSelector } from '../../redux/reduxHooks';
import { clearSelection, getIsQuerySelected, selectQuery } from '../redux/selectionSlice';
import { TABLE_ROW_HEIGHT } from '../../table/constants/sizes';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { CELL_BORDER_WIDTH } from '../../table/constants/sizes';
import { Text } from 'foundations-components/components/Text';
import { useTrellisTheme } from '../../utils/useTrellisTheme';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Row = styled.tr.withConfig({
  displayName: "SelectQueryRow__Row",
  componentId: "sc-1usmoac-0"
})(["background-color:", ";height:", "px;box-shadow:inset 0 -", "px ", ";"], props => props.$theme.color['fill-secondary-subtle'], TABLE_ROW_HEIGHT, CELL_BORDER_WIDTH, props => props.$theme.color['border-primary-default']);
const SelectQueryRow = ({
  rowIds,
  columnCount,
  totalRowCount,
  CustomSelectAllComponent
}) => {
  const theme = useTrellisTheme();
  const dispatch = useTableDispatch();
  const isQuerySelected = useTableSelector(getIsQuerySelected);
  const selectEverything = useCallback(() => dispatch(selectQuery()), [dispatch]);
  const clearAllSelections = useCallback(() => dispatch(clearSelection()), [dispatch]);
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx(Row, {
      "data-test-id": "select-query-row",
      $theme: theme,
      children: /*#__PURE__*/_jsx("td", {
        colSpan: columnCount,
        children: /*#__PURE__*/_jsx(Text, {
          as: "small",
          paddingInlineStart: "1700",
          children: isQuerySelected ? /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx(FormattedMessage, {
              useGap: true,
              message: "datatable.bulkActions.querySelected",
              options: {
                count: totalRowCount
              }
            }), /*#__PURE__*/_jsx(UIButton, {
              "data-test-id": "clear-selection-button",
              use: "link",
              onClick: clearAllSelections,
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "datatable.bulkActions.clearSelection"
              })
            })]
          }) : /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx(FormattedMessage, {
              useGap: true,
              message: "datatable.bulkActions.pageSelected",
              options: {
                count: rowIds.length
              }
            }), /*#__PURE__*/_jsx(CustomSelectAllComponent, {
              selectEverything: selectEverything,
              totalRowCount: totalRowCount
            })]
          })
        })
      })
    })
  );
};
export default SelectQueryRow;